var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}],staticStyle:{"margin":"8px"},domProps:{"innerHTML":_vm._s(_vm.detail)}})
}
var staticRenderFns = []

export { render, staticRenderFns }